var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCantiere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8545 8.22857H26.8205V16.3019H21.5418V23.9288H34.6027V16.2825H29.324V8.22857H36.097L12.2652 0L0 8.22857H6.9283L4.1531 33.4771H0V36H3.8814H20.9014H36.097V33.4771H20.6102L17.8545 8.22857ZM32.0798 21.3865H24.0647V18.8054H32.0798V21.3865ZM8.83019 14.0119H15.9526L16.2825 16.9617H8.51968L8.83019 14.0119ZM8.22857 19.4846H16.5542L16.8841 22.4345H7.89865L8.22857 19.4846ZM17.1558 24.9574L17.4857 27.9073H7.29704L7.62696 24.9574H17.1558ZM12.634 2.79461L21.0566 5.70566H17.5828H8.3062L12.634 2.79461ZM15.3121 8.22857L15.6615 11.4889H9.10189L9.45121 8.22857H15.3121ZM6.69542 33.4771L7.02534 30.4302H17.738L18.0679 33.4771H6.69542Z",
    fill: "#08A2AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCantiere);
export default __webpack_public_path__ + "static/media/ico-cantiere.c83be767cc484ec18d5283b1f537cdd5.svg";
export { ForwardRef as ReactComponent };